/* eslint-disable */
/** @type {OrderEntity} */
export const order1Fixture = {
  id: `aaa`,
  summary: {},
};

/** @type {OrderEntity} */
export const order2Fixture = {
  id: `bbb`,
  summary: {},
};

/** @type {OrderEntity} */
export const order3Fixture = {
  id: `20200217-133-2`,
  orderKey: `20200217-133-2`,
  summary: {
    startTime: `2020-02-17T05:00:00+11.00`,
    status: `103`,
    orderCode: `133`,
    orderLine: `2`,
    title: `26-30, HASSALL ST, PARRAMATTA`,
    subTitle: `20MPA 20MM 90 SLUMP 59 m&sup3;`,
    customerCode: `1694`,
  },
  details: {
    deliveryAddress: `26-30, HASSALL ST, PARRAMATTA, NSW`,
    product: [`20MPA 20MM 90 SLUMP`],
    qty: {
      ordered: `59`,
      dispatched: `7`,
      uom: `M3`,
    },
    spacing: `30 min`,
    po: `test`,
    boralTel: `1300 552 555`,
    cdLink: `https://stg.boralconnects.com.au/concretedeliveries/portal?ref=portal&orderCode=133&orderLine=2`,
    projectName: ``,
  },
};

/** @type {Array<OrderEntity>} */
export const ordersFixture = [order1Fixture, order2Fixture, order3Fixture];
